import {
  AriaStatus,
  BasicListItem,
  Button,
  ContentArea,
  GridPresetList,
  GridPresetSidebar,
  GridRow,
  HeroBasic,
  LoadingOverlay,
  ToastMessage,
} from "/App.Components";
import { ContentAreaType } from "/Models/Generated/ContentAreaType";
import "./BasicListPage.scss";
import { BasicListPageProps } from "/Models/Generated/BasicListPageProps";
import BasicListClient, { BasicListResult } from "./BasicListClient";
import { useState } from "react";
import { BasicListProps } from "/Models/Generated/BasicListProps";
import { ContentAreaItemMargin } from "../../Shared/ContentAreaItem/ContentAreaItem";
import useAriaUpdateHook from "/Helpers/Hooks/useAriaUpdateHook";

const BasicListPage = ({
  pageHero,
  listItems,
  sideBar,
  showMoreButtonText,
  endpoint,
  basicListPageId,
  language,
}: BasicListPageProps) => {
  const [basicList, setBasicList] = useState(listItems?.listItems ?? []);
  const [resultsCount, setResultsCount] = useState<number | undefined>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();
  const [noMoreItems, setNoMoreItems] = useState(listItems?.noMoreItems);

  function isBasicListProps(result: BasicListResult): result is BasicListProps {
    return "listItems" in result && !("error" in result);
  }

  function countResults(listItems: any[] | undefined) {
    if (!listItems) return 0;
    return listItems.length;
  }

  function clickHandeler() {
    if (!basicList || basicList.length < 1) return;

    const lastItemId = basicList.length - 1;
    const lastItem = basicList[lastItemId];
    const isFromCollection = lastItem.isFromCollection;

    setLoading(true);
    setError(undefined);

    const client = new BasicListClient(endpoint);

    client
      .GetMoreBasicItems(
        basicListPageId,
        language ?? "",
        lastItemId + 1,
        isFromCollection,
      )
      .then((result) => {
        if ("error" in result) {
          setError(result.message);
        } else if (isBasicListProps(result)) {
          setNoMoreItems(result.noMoreItems);
          setBasicList((prev) => prev.concat(result.listItems ?? []));
          setResultsCount(countResults(result.listItems));
        }
      })
      .catch((error) => {
        setError(error.message || "An error occurred");
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const { ariaStatus } = useAriaUpdateHook(resultsCount, true);

  return (
    <div className="basic-list-page-norad">
      <AriaStatus message={ariaStatus} />
      <ToastMessage
        message={error ?? ""}
        visible={!!error}
        onClose={() => setError("")}
      />
      <LoadingOverlay loading={loading} />
      {pageHero && <HeroBasic {...pageHero} />}
      <div className="basic-list-page-norad__main-content">
        <GridRow>
          <GridPresetList>
            <div className="basic-list-page-norad__basic-list">
              {basicList &&
                basicList.map((listItem, i) => (
                  <BasicListItem key={i} {...listItem} />
                ))}
            </div>
            {!noMoreItems && (
              <div className="basic-list-page-norad__button-wrapper">
                <Button
                  onClick={clickHandeler}
                  size="m"
                  style="primary"
                  label={showMoreButtonText ?? ""}
                />
              </div>
            )}
          </GridPresetList>
          <GridPresetSidebar>
            <aside>
              <ContentArea
                {...sideBar}
                margin={ContentAreaItemMargin.Sidebar}
                contentAreaType={ContentAreaType.OneThird}
              />
            </aside>
          </GridPresetSidebar>
        </GridRow>
      </div>
    </div>
  );
};

export default BasicListPage;
